'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var RICH_TEXT = exports.RICH_TEXT = 'Messages:RichText';
var BLOCKING = exports.BLOCKING = 'Messages:Blocking';
var SALES_PRO_2017 = exports.SALES_PRO_2017 = 'SalesPro:2017';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/constants/Gates.js
// module id = 284
// module chunks = 0 1